import styled from 'styled-components'

export const PartnerLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;

  img {
    max-width: 70px;
    height: auto;
    vertical-align: middle;
    margin-left: 8px;
  }
`
